<template>
    <div v-if="!isLoaded" class="server-errors single-page" style="overflow:hidden;position:relative;z-index:9999999">
        <div class="container-xxl">
            <div class="content p-3 d-flex justify-content-center align-items-center flex-column">
                <div style="display:flex;justify-content:center" :style="{width: isPage ? '100vw' : '100%',height: isPage ? '100vh' : '100%'}">
                    <!--<img src="@/assets/svg/loading.svg" style="width: 20%" />-->
                    <img src="@/assets/svg/logo-colorful.svg" class="flashing-logo"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "PageLoader",
  props: {
    isPage: {
      type: Boolean,
      default: false,
    },
    isLoaded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style scoped>
.flashing-logo{
    width: 170px;
    max-width: 42vw;
    transition: .2s;
}

@media (max-width: 768px){
    .flashing-logo{
        width: 170px;
        max-width: 52vw;
    }
}
</style>